import classnames from 'classnames'
import Speaker from '../speaker'
import s from './style.module.css'

export default function SpeakerList({ speakers, className = '' }) {
	if (speakers?.length > 0) {
		return (
			<div className={classnames(s.container, className)}>
				{speakers.map((speaker) => (
					<Speaker key={speaker.name} {...speaker} />
				))}
			</div>
		)
	}
	return null
}
